
const addNewUser = async (user) => {

    if (user.username !== "" && user.password !== "" && user.role !== "") {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", localStorage.getItem("token"));

      var raw = JSON.stringify({
        username: user.username,
        password: user.password,
        role: user.role
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      return fetch(`${process.env.REACT_APP_API_URL}/add_new_user`, requestOptions)
      .then((response) => {
        return response.status;
      })
      .catch((error) => {throw new Error(error)});
    }
}

export default addNewUser